<template>
    <div></div>
</template>

<script>
  export default {
    name: 'ExtensionMan'
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/extension/ExtensionMan.vue